import Top from '@/templates/Top'
import About from '@/templates/About'
import DrawTest from '@/templates/DrawTest'
import Unauthorized from '@/templates/Unauthorized'
import Forbidden from '@/templates/Forbidden'
import NotFound from '@/templates/NotFound'
import SignUp from '@/templates/SignUp'
import SignIn from '@/templates/SignIn'
import PasswordReset from '@/templates/PasswordReset'
import SignInWithEmail from '@/templates/SignInWithEmail'
import SentEmailToSignIn from '@/templates/SentEmailToSignIn'
import SentVerificationMail from '@/templates/SentVerificationMail'
import SentPasswordResetMail from '@/templates/SentPasswordResetMail'
import RequiredEmailVerification from '@/templates/RequiredEmailVerification'
import UserVerifyEmail from '@/templates/UserVerifyEmail'
import UserTop from '@/templates/UserTop'
import UserDrill from '@/templates/UserDrill'
import UserDrills from '@/templates/UserDrills'
import UserDrillsProgress from '@/templates/UserDrillsProgress'
import UserAnswer from '@/templates/UserAnswer'
import Settings from '@/templates/Settings'
import PostStartPage from '@/templates/PostStartPage'
import PostExplanation from '@/templates/PostExplanation'
import Post from '@/templates/Post'
import PostDetail from '@/templates/PostDetail'
import Posts from '@/templates/Posts'
import PostCategories from '@/templates/PostCategories'
import PostTags from '@/templates/PostTags'
import PostGroupItems from '@/templates/PostGroupItems'
import AdminTop from '@/templates/AdminTop'
import AdminServices from '@/templates/AdminServices'
import AdminServiceCreate from '@/templates/AdminServiceCreate'
import AdminServiceEdit from '@/templates/AdminServiceEdit'
import AdminUsers from '@/templates/AdminUsers'
import AdminUser from '@/templates/AdminUser'
//import AdminUsers from '@/templates/AdminUsers'
//import UserCreate from '@/templates/UserCreate'
//import UserEdit from '@/templates/UserEdit'
import AdminSignIn from '@/templates/AdminSignIn'
import AdminPost from '@/templates/AdminPost'
import AdminPostCreate from '@/templates/AdminPostCreate'
import AdminPostEdit from '@/templates/AdminPostEdit'
import AdminPosts from '@/templates/AdminPosts'
import AdminPostGroups from '@/templates/AdminPostGroups'
import AdminPostGroup from '@/templates/AdminPostGroup'
import AdminPostGroupCreate from '@/templates/AdminPostGroupCreate'
import AdminPostGroupEdit from '@/templates/AdminPostGroupEdit'
import AdminCategories from '@/templates/AdminCategories'
import AdminCategoryCreate from '@/templates/AdminCategoryCreate'
import AdminCategoryEdit from '@/templates/AdminCategoryEdit'
import AdminShortenUrlCreate from '@/templates/AdminShortenUrlCreate'
import AdminShortenUrlEdit from '@/templates/AdminShortenUrlEdit'
import AdminShortenUrl from '@/templates/AdminShortenUrl'
import AdminShortenUrls from '@/templates/AdminShortenUrls'
import CategoriesPage from '@/templates/CategoriesPage'

export default [
  {
    path: '/',
    component: Top,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/signup/sent',
    name: 'SentVerificationMail',
    component: SentVerificationMail,
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/password-reset/sent',
    name: 'SentPasswordResetMail',
    component: SentPasswordResetMail,
  },
  {
    path: '/errors/required-email-verification',
    name: 'RequiredEmailVerification',
    component: RequiredEmailVerification,
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset,
  },
  {
    path: '/email-auth',
    name: 'SignInWithEmail',
    component: SignInWithEmail,
  },
  {
    path: '/email-auth/sent',
    name: 'SentEmailToSignIn',
    component: SentEmailToSignIn,
  },
  {
    path: '/user/verify-email',
    name: 'UserVerifyEmail',
    component: UserVerifyEmail,
    //meta: { requiresAuth: true }
  },
  {
    path: '/user',
    name: 'UserTop',
    component: UserTop,
    meta: { requiresAuth: true },
  },
  {
    path: '/user/drills/:drillId',
    name: 'UserDrill',
    component: UserDrill,
    meta: { requiresAuth: true },
  },
  {
    path: '/user/drills',
    name: 'UserDrills',
    component: UserDrills,
    meta: { requiresAuth: true },
  },
  {
    path: '/user/drills/progress/:serviceId',
    name: 'UserDrillsProgress',
    component: UserDrillsProgress,
    meta: { requiresAuth: true },
  },
  {
    path: '/user/answers/:answerId',
    name: 'UserAnswer',
    component: UserAnswer,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true },
  },
  {
    path: '/categories/:serviceId/:categorySlug',
    name: 'CategoriesPage',
    component: CategoriesPage,
  },
  {
    path: '/posts/:serviceId/categories/:categorySlug?',
    name: 'PostCategories',
    component: PostCategories,
  },
  {
    path: '/posts/:serviceId/tags/:tagLabel?',
    name: 'PostTags',
    component: PostTags,
  },
  {
    path: '/posts/:serviceId/start',
    name: 'PostStartPage',
    component: PostStartPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/posts/:serviceId/:slug/explanation',
    name: 'PostExplanation',
    component: PostExplanation,
  },
  {
    path: '/posts/:serviceId/groups/:slug',
    name: 'PostGroupItems',
    component: PostGroupItems,
  },
  {
    path: '/posts/detail/:postId',
    name: 'PostDetail',
    component: PostDetail,
  },
  {
    path: '/posts/:serviceId/:slug',
    name: 'Post',
    component: Post,
  },
  {
    path: '/posts/:serviceId',
    name: 'Posts',
    component: Posts,
  },
  {
    path: '/admin/signin',
    name: 'AdminSignIn',
    component: AdminSignIn,
  },
  {
    path: '/admin/services',
    name: 'AdminServices',
    component: AdminServices,
    meta: {
      requiresAuth: true,
      requiresRoleAdmin: true,
    },
  },
  {
    path: '/admin/services/create',
    name: 'AdminServiceCreate',
    component: AdminServiceCreate,
    meta: {
      requiresAuth: true,
      requiresRoleAdmin: true,
    },
  },
  {
    path: '/admin/services/:serviceId/edit',
    name: 'AdminServiceEdit',
    component: AdminServiceEdit,
    meta: {
      requiresAuth: true,
      requiresRoleAdmin: true,
    },
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: {
      requiresAuth: true,
      requiresRoleAdmin: true,
    },
  },
  {
    path: '/admin/users/:username',
    name: 'AdminUser',
    component: AdminUser,
    meta: {
      requiresAuth: true,
      requiresRoleAdmin: true,
    },
  },
  //{
  //  path: '/admin/users/create',
  //  name: 'AdminUserCreate',
  //  component: UserCreate,
  //  meta: { requiresAuth: true }
  //},
  //{
  //  path: '/admin/users/:uid/edit',
  //  name: 'AdminUserEdit',
  //  component: UserEdit,
  //  meta: { requiresAuth: true }
  //},
  {
    path: '/admin/posts/:serviceId',
    name: 'AdminPosts',
    component: AdminPosts,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/create',
    name: 'AdminPostCreate',
    component: AdminPostCreate,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/groups',
    name: 'AdminPostGroups',
    component: AdminPostGroups,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/groups/create',
    name: 'AdminPostGroupCreate',
    component: AdminPostGroupCreate,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/groups/:slug/edit',
    name: 'AdminPostGroupEdit',
    component: AdminPostGroupEdit,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/groups/:slug',
    name: 'AdminPostGroup',
    component: AdminPostGroup,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/categories/:serviceId',
    name: 'AdminCategories',
    component: AdminCategories,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/categories/:serviceId/create',
    name: 'AdminCategoryCreate',
    component: AdminCategoryCreate,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/categories/:serviceId/:slug/edit',
    name: 'AdminCategoryEdit',
    component: AdminCategoryEdit,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/:postId',
    name: 'AdminPost',
    component: AdminPost,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/posts/:serviceId/:postId/edit',
    name: 'AdminPostEdit',
    component: AdminPostEdit,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/shorten-urls/:serviceId/create',
    name: 'AdminShortenUrlCreate',
    component: AdminShortenUrlCreate,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/shorten-urls/:serviceId/:urlId/edit',
    name: 'AdminShortenUrlEdit',
    component: AdminShortenUrlEdit,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/shorten-urls/:serviceId/:urlId',
    name: 'AdminShortenUrl',
    component: AdminShortenUrl,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin/shorten-urls/:serviceId',
    name: 'AdminShortenUrls',
    component: AdminShortenUrls,
    meta: {
      requiresAuth: true,
      requiresAcceptService: true,
    },
  },
  {
    path: '/admin',
    name: 'AdminTop',
    component: AdminTop,
    meta: { requiresAuth: true },
  },
  { path: '/draw-test', component: DrawTest },
  { path: '/about', component: About },
  { path: '/error/forbidden', component: Forbidden, name: 'Forbidden' },
  { path: '/error/unauthorized', component: Unauthorized },
  { path: '/error/notfound', component: NotFound },
  { path: '*', redirect: '/error/notfound' },
]
